import { Component, Input } from "@angular/core";
import { FiatWallet, Provider } from "@models";
import { FiatWalletService } from "../../services/wallet/fiat_wallet.service";
import { BpModalHasSave } from "@models/interfaces/bp-modal-has-save";
import { FiatTransaction } from "@models/transaction";
import { UserService } from "@main-services/user.service";
import { CustomModal } from "../../../core/components/base-modals";

@Component({
	templateUrl: "./fiat-wallet-qr-modal.component.html",
	styleUrls: ["./fiat-wallet-qr-modal.component.scss"],
	standalone: false
})
export class FiatWalletQrModalComponent extends CustomModal implements BpModalHasSave {
	@Input()
	public transaction: FiatTransaction = null;
	@Input()
	public provider: Provider = null;

	public constructor(
		private userService: UserService,
		private fiatWalletService: FiatWalletService
	) {
		super();
	}

	public save(): void {
		this.fiatWalletService.download(
			this.fiatWallet,
			this.amount,
			this.provider.getId(),
			this.userService.user.getId()
		);
	}

	public close(): void {
		this.closeAll(true);
	}

	public get amount(): number {
		return this.transaction.getAmount();
	}

	public get fiatWallet(): FiatWallet {
		return this.fiatWalletService.getItemById(this.transaction.getFiatWalletId());
	}

	public onClickBack(): void {
		super.close();
	}
}
